

const initialState = [];

const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PROJECTS':
      return action.payload;
    case 'SET_PROJECT':
      return action.payload; // Return the single project as an object
    default:
      return state;
  }
};


export default projectsReducer;
